export default {
  'teamsMessageTrace.title': 'Teams Message Traces',
};
